<template>
  <el-dialog title="输入验证码" :visible.sync="showVerCode" :close-on-click-modal="false" width="360px" :before-close="handleClose">
    <div class="content-center">
      <img id="verImg" :src="imgVer.codeImg" width="194px" height="70px" />
    </div>
    <div class="content-center-column">
      <div class="content-center">
        <div>
          <el-input class="input-code" :value="imgVer.verifyCode" @input="changeCode" @change="enterCode" placeholder="输入验证码"></el-input>
        </div>
        <el-button class="content-center input-right" @click="showCode"><i class="el-icon-refresh"></i></el-button>
      </div>
      <el-button type="primary" :loading="submiting" class="content-center submit-btn" :style="imgVer.verifyCode ? 'opacity: 1' : 'opacity: 0.5'" @click="enterCode">
        <span v-if="!submiting">提交验证</span>
        <span v-else>请稍后...</span>
      </el-button>
      <div style="height: 30px;">
        <div style="line-height: 30px; color: red;">{{errorCode}}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { httpAjax } from "@/api/ajax";

export default {
  name: 'GetCode',
  props: {
    showVerCode: {
      type: Boolean,
      default: false
    },
    phone: String || Number,
    type: String

  },
  data() {
    return {
      errorCode: '',
      imgVer: {
        codeImg: '',
        key: '',
        verifyCode: ''
      },
      submiting: false,
    }
  },
  created() {
    this.showCode()
  },
  methods: {
    handleClose(){
      this.$emit('closeDialog')
    },
    // 提交验证码
    enterCode() {
      if (this.imgVer.verifyCode === '') {
        this.errorCode = '请输入验证码';
        return;
      }
      this.submiting = true;
      if(this.type == 'up'){
        httpAjax({
          url: '/services/verify/send/verifySms',
          method: "get",
          data: {
            key: this.imgVer.key,
            phoneNumber: this.phone,
            verifyCode: this.imgVer.verifyCode,
            type: 'up'
          }
        }).then((response) => {
          if (response.success) {
            this.handleClose()
            this.$emit('successCode')
            this.codeIsSend = true;
            this.count = 60;
            this.timeFun();
          } else {
            this.errorCode = response.msg;
          }
          this.submiting = false;
        });
      } 
      if(this.type == 'email'){
        httpAjax({
          url: '/services/verify/send/verifySms/email',
          method: "get",
          data: {
            key: this.imgVer.key,
            email: this.phone,
            verifyCode: this.imgVer.verifyCode,
          }
        }).then((response) => {
          if (response.success) {
            this.handleClose()
            this.codeIsSend = true;
            this.$emit('successCode')
            this.count = 60;
            this.timeFun();
          } else {
            this.errorCode = response.msg;
          }
          this.submiting = false;
        });
      }
     
      
    },
    // 输入验证码
    changeCode(value) { 
      this.imgVer.verifyCode = value;
    },
    // 显示验证码
    showCode() {

      httpAjax({
        url: '/services/verify/captcha',
        method: "get",
      }).then((response) => {
        if (response.success) {
					this.imgVer.codeImg = response.data.image;
          this.imgVer.key = response.data.key;
          this.showVerCode = true;
          this.errorCode = ''
				} else {
					this.$message({
            message: response.msg,
            type: 'error'
          })
				}
      });
    },
    // 倒计时
    timeFun() {
      this.count = 60;
      this.timer = setInterval(() => {
        if(this.count === 1) {
          this.codeIsSend = false;
          clearInterval(this.timer);
        } else {
          this.count--;
        }
      }, 1000);
    },
  },
}
</script>

<style scoped lang='less'>
.input-code {
  /deep/ .el-input__inner {
    line-height: 32px;
    width: 160px;
    height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #dddddd;
    margin-right: 9px;
  }
  /deep/ .el-input__inner::-webkit-input-placeholder {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #bfbfbf;
    line-height: 20px;
  }
}

.input-right {
  width: 32px;
  height: 32px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #dddddd;
}

/deep/ .el-dialog {
  margin-top: 40vh !important;
  .el-dialog__header {
    padding: 16px 24px;
    border-bottom: 1px solid #f5f5f5;
  }
  .el-dialog__body {
    padding: 0 0 24px 0;
  }

  .submit-btn {
    width: 206px;
    height: 32px;
    background: rgba(17, 112, 235);
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    margin-top: 16px;
    border: none;
  }
}
</style>
